import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c55e3c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex inputFilter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inputSearchIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-suche" })
], -1))
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-filter" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "notification"
}

import { ref, computed } from "vue";
import { Store } from "@bryntum/grid";
import { useGlobalStore } from "@/stores/GlobalStore";
import { TableType, PopupType } from "@/utilities/enums/Enums";
import { $t } from "@/utilities/i18n/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'GridInputFilter',
  props: {
    gridStore: Store,
		popupType: Number,
		hideFilterButton: {
      type: Boolean,
      default: false,
    }
},
  setup(__props) {

const props = __props

const globalStore = useGlobalStore();

const userFilters = computed(()=>{
	return globalStore.userPreferences.userFilters;
});
const userHiddenColumns = computed(()=>{
	return globalStore.userPreferences.userHiddenColumns;
});



const activeFilters = () => {
	let filterCount = 0;
	let tableType = null as TableType|null;

	switch (props.popupType){
		case PopupType.locationFilterPopup: {
			tableType = TableType.location;
			break;
		}
		case PopupType.userFilterPopup: {
			tableType = TableType.user;
			break;
		}
		case PopupType.disdiFilterPopup: {
			tableType = TableType.disdi;
			break;
		}
    case PopupType.registrationFilterPopup:{
      tableType = TableType.register;
      break;
    }
    case PopupType.locationReportsFilterPopup:{
      tableType = TableType.registerLocation;
      break;
    }
		default: {
			console.log("can't compute activeFilters, unknown popupType");
			break;
		}
	}

  if (tableType === null) return;

	const filters = userFilters.value.filter(f => f.tableName === TableType[tableType]);
	const hiddenColumns = userHiddenColumns.value.filter(f => f.tableName === TableType[tableType]);

	filterCount = filters.length + hiddenColumns.length;
	return filterCount;
}

const reactToInput = () => {
	if (searchTerm.value === "") props.gridStore.removeFilter("gridInputFilter");

	props.gridStore.filter({
		id: "gridInputFilter",
		filterBy : (record) => {
			// get all propertie-key, then properties, filter out nulls and none-strings
			const allProps = Object.keys(record.data).map(k => record.data[k]);

			const stringProps = allProps.filter(p => p !== null && typeof p === "string");
      const numberProps = allProps.filter(p => p !== null && typeof p === "number").map(np => `${np}`);

      const searchableProps = stringProps.concat(numberProps);

			// make term and prop lowercase and find any match
			return searchableProps.some(sp => sp.toLowerCase().includes(searchTerm.value.toLowerCase()));
		}
	});
};

let searchTerm = ref(null);

const showModal = () => {
	let tableType = null as TableType|null;
	let popupTitle = null;

	switch (props.popupType){
		case PopupType.locationFilterPopup: {
			tableType = TableType.location;
			popupTitle = $t("popups.locationFilter.title");
			break;
		}
		case PopupType.userFilterPopup: {
			tableType = TableType.user;
			popupTitle = $t("popups.userFilter.title");
			break;
		}
		case PopupType.registrationFilterPopup: {
			tableType = TableType.register;
			popupTitle = $t("popups.register.title");
			break;
		}
    case PopupType.locationReportsFilterPopup: {
      tableType = TableType.registerLocation;
      popupTitle = $t("popups.registerLocation.title");
      break;
    }
    case PopupType.disdiFilterPopup: {
      tableType = TableType.disdi;
      popupTitle = $t("popups.disdiFilter.title");
      break;
    }
		default: {
			console.log("can't show modal, unknown popupType");
			break;
		}
	}

  if (tableType === null || popupTitle === null) return;

	const callback = async () => {
		await globalStore.updateTablePreferences({userId: globalStore.user.id, tableName: TableType[tableType]});
	};

	globalStore.openPopup({data: {}, action: callback, resetButton:true, title: popupTitle, type: props.popupType});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTerm) ? (searchTerm).value = $event : searchTerm = $event)),
        placeholder: "Suchen...",
        onInput: reactToInput
      }, null, 544), [
        [_vModelText, _unref(searchTerm)]
      ])
    ]),
    (!__props.hideFilterButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "inputFilterButton",
          onClick: showModal
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (!__props.hideFilterButton)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(activeFilters()), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})